var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonOn01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "12.557px",
    height: "9.313px",
    viewBox: "80.898 156.16 12.557 9.313",
    enableBackground: "new 80.898 156.16 12.557 9.313",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "92.041,156.16 85.555,162.644 82.312,159.402 80.898,160.816 85.555,165.473 93.455,157.574  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonOn01);
export default __webpack_public_path__ + "static/media/button_on-01.19e24f7c9ec9c4b9a757265b7f77e4d0.svg";
export { ForwardRef as ReactComponent };